import React, { useEffect } from "react";
import styles from "./PaymentPage.module.scss";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Button from "components/UI/Button/Button";
import TransactionReceipt from "components/TransactionReceipt/TransactionReceipt";
import toast from "components/Toast/toast";
import { combineClasses } from "utils/utils";

const PaymentPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);

  const status = urlParams.get("success") === "true";
  const showReceipt = urlParams.get("receipt") === "true";

  useEffect(() => {
    if (status) {
      // toast.success("Here is your payment receipt");
    } else {
      navigate("/payment-plan");
    }
  }, []);

  return (
    <>
      {status && (
        <section className={styles.PaymentPage}>
          <section className={styles.PaymentPageUpgrade}>
            <div>
              <svg
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.78013 14.4995C5.63301 14.5001 5.48876 14.4471 5.36414 14.3465C5.23953 14.2459 5.13967 14.1019 5.07616 13.9313C5.01265 13.7606 4.98811 13.5703 5.00537 13.3824C5.02264 13.1945 5.08101 13.0168 5.1737 12.8699L12.8708 2.67256C12.9285 2.58686 13.0072 2.52895 13.0939 2.50833C13.1806 2.48772 13.2702 2.50562 13.3479 2.55909C13.4257 2.61257 13.487 2.69845 13.5218 2.80263C13.5566 2.90682 13.5628 3.02312 13.5394 3.13244L12.0466 9.15087C12.0026 9.30236 11.9878 9.46531 12.0036 9.62576C12.0193 9.7862 12.065 9.93935 12.1369 10.0721C12.2088 10.2048 12.3046 10.3131 12.4162 10.3877C12.5277 10.4623 12.6517 10.501 12.7775 10.5005H18.2199C18.367 10.4999 18.5112 10.5529 18.6359 10.6535C18.7605 10.7541 18.8603 10.8981 18.9238 11.0687C18.9873 11.2394 19.0119 11.4297 18.9946 11.6176C18.9774 11.8055 18.919 11.9832 18.8263 12.1301L11.1292 22.3274C11.0715 22.4131 10.9928 22.471 10.9061 22.4917C10.8194 22.5123 10.7298 22.4944 10.6521 22.4409C10.5743 22.3874 10.513 22.3015 10.4782 22.1974C10.4434 22.0932 10.4372 21.9769 10.4606 21.8676L11.9534 15.8491C11.9974 15.6976 12.0122 15.5347 11.9964 15.3742C11.9807 15.2138 11.935 15.0607 11.8631 14.9279C11.7912 14.7952 11.6954 14.6869 11.5838 14.6123C11.4723 14.5377 11.3483 14.499 11.2225 14.4995H5.78013Z"
                  fill="#6570FC"
                  stroke="#6570FC"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>

            <p className={styles.upgradeText}>
              "Ready to level up your experience? Upgrade to our annual plan and save the cost of three and a half months."
            </p>

            <div>
              <Button className={styles.upgrade_button} variant={"filled"}>
                <Link
                  to="/payment-plan"
                  className={combineClasses(
                    styles.upgrade_link_btn,
                    `unstyledLink`
                  )}
                >
                  Upgrade Now
                </Link>
              </Button>
            </div>
          </section>
          <p>Your Active Plan</p>
          <TransactionReceipt showReceipt={showReceipt} />
        </section>
      )}
    </>
  );
};

export default PaymentPage;
